import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AppComponent from './App.jsx';
import { getFirebase } from './services/firebase.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ToastProvider } from './contexts/ToastContext';
import { installImageFallback } from './services/storageFallback';
import { startUsageReporting } from "./oneadmin/usage";
import "./oneadmin/access";
import "./oneadmin/help";

// Initialize Firebase early
getFirebase();

// Cake images: fall back to the Cloud Functions host when Firebase Storage is blocked
installImageFallback();

// Apply saved theme before first render
(function () {
  const saved = localStorage.getItem('appTheme') || 'system';
  if (saved === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
  } else {
    document.documentElement.setAttribute('data-theme', saved);
  }
}());

// Phone status bar = the colour of the bar under it. theme-color was a fixed #fa4848, while the
// top bar is a darker red in the dark theme, so the two showed two shades of red.
(function syncStatusBarColour() {
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) { meta = document.createElement('meta'); meta.name = 'theme-color'; document.head.appendChild(meta); }
  let queued = false;
  const sync = () => {
    queued = false;
    const bar = document.querySelector('.top-bar, .is-top-toolbar');
    const colour = bar ? getComputedStyle(bar).backgroundColor : '';
    const value = colour && colour !== 'rgba(0, 0, 0, 0)' ? colour
      : (document.documentElement.getAttribute('data-theme') === 'dark' ? '#b52e2e' : '#fa4848');
    if (meta.getAttribute('content') !== value) meta.setAttribute('content', value);
  };
  const later = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
  new MutationObserver(later).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'], childList: true, subtree: true });
  window.addEventListener('load', later);
  later();
}());

try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ToastProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppComponent />
      </Router>
    </ToastProvider>
  );

  // Register the service worker
  serviceWorkerRegistration.register();
} catch (error) {
  console.error('Error starting React app:', error.message, error.stack);
}
startUsageReporting();
